export default __webpack_public_path__ + "static/fr-fbf9cffa43ddf03f365ea0934ba81c59.svg";